import React from "react";
import { Link } from "react-router-dom";

const BUCKETS = [
  { key: "open", label: "Open", cls: "text-blue-600" },
  { key: "in_progress", label: "In progress", cls: "text-violet-600" },
  { key: "pending_client", label: "Pending client", cls: "text-amber-600" },
  { key: "completed", label: "Completed", cls: "text-emerald-600" },
];

// A row of 4 clickable ticket-status-bucket counts, deep-linking to the
// Tickets page pre-filtered by project/organization + bucket.
export default function TicketCountRow({ projectId, organizationId, counts, className = "" }) {
  const c = counts || {};
  return (
    <div className={`grid grid-cols-4 gap-1.5 ${className}`} data-testid="ticket-count-row">
      {BUCKETS.map((b) => {
        const params = new URLSearchParams({ bucket: b.key });
        if (projectId) params.set("project_id", projectId);
        if (organizationId) params.set("organization_id", organizationId);
        return (
          <Link
            key={b.key}
            to={`/tickets?${params.toString()}`}
            className="rounded-md bg-slate-50 hover:bg-slate-100 border border-slate-100 px-2 py-1.5 text-center transition-colors"
            data-testid={`ticket-count-${b.key}`}
            title={`${b.label} tickets`}
          >
            <div className={`text-sm font-semibold ${b.cls}`}>{c[b.key] ?? 0}</div>
            <div className="text-[9px] uppercase tracking-wide text-slate-400 leading-tight mt-0.5">{b.label}</div>
          </Link>
        );
      })}
    </div>
  );
}
